import { ArrowUDownLeftIcon } from './ArrowUDownLeftIcon';

/**
 * author: Colton Wiscombe
 * id D16AF4C4-90FC-42AB-8847-7F04DFDC6DF4
 * name arrow-u-down-left
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-u-down-left.svg
 * tags
 */
export const UTurnLeftIcon = ArrowUDownLeftIcon;
export default UTurnLeftIcon